var _style, _path, _path2, _path3, _path4, _path5, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 140 140",
    style: {
      enableBackground: "new 0 0 140 140"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#3873FF;}\n\t.st2{fill:none;stroke:#FFFFFF;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;}\n\t.st3{fill:none;stroke:#FFFFFF;stroke-width:3;}\n\t.st4{fill:#3873FF;}\n\t.st5{fill:url(#SVGID_00000012459422296875429380000008297049612535410096_);}\n\t.st6{opacity:0.3;fill:#0000FF;enable-background:new    ;}\n\t.st7{opacity:0.6;fill:#FF0000;enable-background:new    ;}\n\t.st8{opacity:0.7;fill:#0000FF;enable-background:new    ;}\n\t.st9{fill:#FF0000;}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 84.1,
    y1: 59.2,
    x2: 84.1,
    y2: 79.73
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0003FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0003FD"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M95.1,59.2v13c-2.7,3.7-11.8,7-22,7.5V63.2C86,63,91.1,60.7,95.1,59.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M101,109.9l9,4.7l0,0c0.9,0.5,1.2,1.6,0.8,2.4c-0.5,0.9-1.6,1.2-2.5,0.8l-9.1-4.7l-4.4-2.4 c-2.2-1.2-4.1-2.9-5.6-4.8c-1.6-2.1-2.5-4.6-2.4-7.3V98c-4.5,4.4-10.6,7-17,7.1c-6.2-0.1-12.1-2.5-16.6-6.7v0.2 c0,2.6-0.8,5.2-2.4,7.3c-1.5,2-3.4,3.6-5.6,4.8l-4.2,2.4l-9.2,4.8c-0.9,0.5-2,0.1-2.5-0.8c-0.5-0.9-0.1-2,0.8-2.4l9.1-4.7l4.2-2.4 c1.8-1,3.3-2.4,4.6-4c1.1-1.4,1.7-3.2,1.7-5v-4.1c-2.5-3.2-4.5-6.7-6-10.5c-6.2-3.5-9.9-8.1-9.9-13.3V44.1c0-1.7,0.6-3.4,1.9-4.6 c1.9-1.9,5.1-2.9,9.4-3.4C50.1,27.4,59.6,22,69.8,22c10.2,0,19.7,5.4,24.8,14.1h0c4.6,0.5,8,1.5,10,3.5c1.2,1.2,1.9,2.8,1.9,4.5 v26.7c0,5.4-4,10.2-10.7,13.7c-1.3,3.4-3.1,6.6-5.4,9.5v4.6c0,1.8,0.6,3.6,1.8,5c1.2,1.6,2.8,2.9,4.5,4L101,109.9z M102.8,44.1 c0-0.7-0.3-1.4-0.8-1.9c-1.6-1.2-3.4-1.9-5.4-2.1c1.1,2.6,1.9,5.4,2.2,8.2C101.5,46.9,102.8,45.4,102.8,44.1z M69.8,25.7 c8,0,15.4,3.8,20.1,10.1c0.9,1.2,1.7,2.5,2.4,3.8c1.3,2.5,2.2,5.1,2.7,7.9c0.1,0.8,0.2,1.6,0.3,2.4c-0.9,0.3-1.8,0.6-2.8,0.9 c-7.3,2-14.8,2.9-22.4,2.8c-7.8,0.1-15.5-0.9-23-3c-1-0.3-2-0.7-2.9-1c0.1-0.7,0.2-1.5,0.3-2.2l0,0c0.5-2.7,1.4-5.4,2.7-7.9 c0.7-1.3,1.5-2.6,2.4-3.8C54.4,29.5,61.9,25.7,69.8,25.7z M42.9,40.2c-1.7,0.2-3.4,0.9-4.7,1.9c-0.5,0.5-0.8,1.2-0.8,1.9 c0,1.2,1.2,2.6,3.4,3.9C41.2,45.3,41.9,42.7,42.9,40.2z M41.9,78.4c-2.8-2.3-4.5-4.9-4.5-7.7V50.1c1,0.7,2,1.3,3.1,1.9 c0.7,0.3,1.3,0.6,2,0.9c0.7,0.3,1.1,0.4,1.7,0.6c0.3,0.1,0.7,0.2,1,0.3c0.3,0.1,0.5,0.2,0.8,0.2v0c7.8,2.2,16,3.3,24.1,3.2 c8,0.1,15.9-0.9,23.6-3c0.4-0.1,0.8-0.3,1.2-0.4c0.2-0.1,0.3-0.1,0.5-0.2c0.6-0.2,1.2-0.4,1.7-0.6c0.1-0.1,0.3-0.1,0.5-0.2 c0.5-0.2,1-0.4,1.5-0.7l0,0c1.3-0.6,2.5-1.3,3.7-2.2v20.6c0,3-1.9,5.9-5.2,8.3c-1.5,1.1-3,2-4.6,2.7c-7.2,3.1-15,4.7-22.9,4.6 c-8.1,0-18.6-2.3-23.6-4.9C45.2,80.6,42.5,79,41.9,78.4z M53.2,93.2c4.5,5.1,10.3,8.2,16.6,8.2c8.7,0,15.8-7.1,17.3-9 c1.3-1.6,2.7-3.7,3.7-5.8c-6.7,2.3-13.7,3.4-20.7,3.3c-7.3,0.1-14.6-1.1-21.5-3.6c0.9,1.9,2.1,3.7,3.3,5.4c0,0.1,0.1,0.1,0.1,0.2 C52.6,92.4,52.8,92.7,53.2,93.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M103.5,102.3c-2.9,6.5-16.8,11.5-33.5,11.5c-18.8,0-34-6.3-34-14c0-4.2,4.4-7.9,11.5-10.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M105,102.5c2.8,0,5-2.2,5-5c0-2.8-2.2-5-5-5s-5,2.2-5,5C100,100.3,102.2,102.5,105,102.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M52.3,92c0-0.1-0.1-0.1-0.1-0.2L52,91.6c-1.1-1.5-2.1-3-3-4.6h-4.1c0.9,1.9,2,3.7,2.9,5H52.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000107590955470406839470000001803087873905771952_",
    gradientUnits: "userSpaceOnUse",
    x1: 56.05,
    y1: 59.41,
    x2: 56.05,
    y2: 79.93
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF1515"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776,
    style: {
      stopColor: "#FD1616"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F91718"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000107590955470406839470000001803087873905771952_)"
    },
    d: "M45,59.4c4,1.5,9.1,3.8,22.1,4v16.5 c-10.2-0.5-19.3-3.7-22.1-7.5V59.4z"
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 48,
    className: "st6",
    width: 10.4,
    height: 10.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 61.5,
    className: "st7",
    width: 10.4,
    height: 10.4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 75,
    className: "st8",
    width: 10.4,
    height: 10.4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 88.5,
    className: "st9",
    width: 10.4,
    height: 10.4
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 17,
    className: "st6",
    width: 10.4,
    height: 10.4
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 30.5,
    className: "st7",
    width: 10.4,
    height: 10.4
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 44,
    className: "st8",
    width: 10.4,
    height: 10.4
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 57.5,
    className: "st9",
    width: 10.4,
    height: 10.4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.3f2ed64d1d5b19a5df9ccad5ca1942ac.svg";
export { ForwardRef as ReactComponent };